import { render, staticRenderFns } from "./Categorii-drepturi_list.vue?vue&type=template&id=65be5da5&scoped=true&"
import script from "./Categorii-drepturi_list.vue?vue&type=script&lang=js&"
export * from "./Categorii-drepturi_list.vue?vue&type=script&lang=js&"
import style0 from "./Categorii-drepturi_list.vue?vue&type=style&index=0&id=65be5da5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65be5da5",
  null
  
)

export default component.exports